
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/onde-comprar",
      function () {
        return require("private-next-pages/onde-comprar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/onde-comprar"])
      });
    }
  